import Ably from "ably";
let ably = null;
export function configureAbly(ablyConfigurationObject) {
    return ably || (ably = new Ably.Realtime.Promise(ablyConfigurationObject));
}
export function assertConfiguration() {
    if (!ably) {
        throw new Error('Ably not configured - please call configureAbly({ key: "your-api-key", clientId: "someid" });');
    }
    return ably;
}
//# sourceMappingURL=AblyReactHooks.js.map